import { cn } from '@ifixit/ui/lib/utils';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { type ComponentProps } from 'react';

interface ButtonProps extends ComponentProps<'button'> {
   asChild?: boolean;
}

const ButtonStyles = cva(
   'flex items-center justify-center gap-2 h-7 md:h-9 px-4 rounded-lg border border-gray-300 hover:border-gray-400 transition-colors duration-150 text-black hover:text-brand-500 font-medium no-underline cursor-pointer disabled:pointer-events-none disabled:opacity-50 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
   {
      variants: {
         variant: {
            default: 'bg-transparent',
            white: 'bg-white',
         },
      },
   }
);

function Button({ className, asChild = false, ...props }: ButtonProps) {
   const Comp = asChild ? Slot : 'button';

   return <Comp data-slot="button" className={cn(className)} {...props} />;
}

export { Button, ButtonStyles };
